<template>
  <section class="w-full max-w-md">
    <h6 class="text-center mb-4">
      {{ $root.pageTitle }}
    </h6>

    <div class="box">
      <form @submit.prevent="lostPassword">
        <div class="field">
          <label class="label">Email</label>
          <div class="control">
            <input
              v-model="email"
              name="email"
              class="input"
              type="email"
              placeholder="Your Email"
              autofocus=""
              required
            >
          </div>
        </div>
        <button
          type="submit"
          class="button is-block is-info is-fullwidth"
          :class="{'is-loading': loading}"
        >
          Reset password
        </button>

        <router-link
          to="/login"
          class="text-center block mt-4"
        >
          Already have an account?
        </router-link>
      </form>
    </div>

    <div
      class="notice-block"
    >
      <div class="content has-text-left">
        <p class="text-center font-bold">
          Lost password process
        </p>
        <p>Enter your email address linked to your AI Lean account and click the "Reset password" button.</p>

        <p>
          <strong>If an account with this address exists</strong>, instructions will be sent to reset your password.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
// eslint-disable-next-line import/extensions
import AuthService from '@/services/auth.service';

const authService = new AuthService();

export default {
  name: 'LoginFormComponent',
  data: () => ({
    email: '',
    loading: false
  }),
  mounted() {
    this.$root.pageTitle = 'Lost Password';
  },
  methods: {
    async lostPassword() {
      try {
        if (this.loading && this.email) return;

        this.loading = true;

        const formData = new FormData();
        formData.append('email', this.email.toLocaleLowerCase());

        const { data: { status, message } } = await authService.forgotPassword(formData);

        if (status === 'success') {
          this.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 5000 } });
          this.email = '';
        } else {
          this.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
        }
      } catch (error) {
        console.error('[ForgotPassword Error]', error);
        this.$root.$emit('showToast', { message: 'Impossible to perform this action.', options: { cssClass: 'is-danger', duration: 10000 } });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
